import * as reference from './botPlacementReference.js';
import * as hard from './botSameTurn.js';
const plans=new WeakMap();
const LEVEL_CONFIG=Object.freeze({easyMaxPlan:4,mediumMaxPlan:9,easyFraction:.04,mediumFraction:.008});
function planning(dictionary,max){let entry=plans.get(dictionary);if(!entry){entry={};plans.set(dictionary,entry);}return entry[max]||(entry[max]=new Set([...dictionary].filter(w=>w.length<=max)));}
function chooseBotPlacement(options){
 if(![1,3].includes(options.difficulty))return hard.chooseBotPlacement(options);
 const easy=options.difficulty===1;
 return reference.chooseBotPlacement({...options,difficulty:3,planningDictionary:planning(options.dictionary,easy?LEVEL_CONFIG.easyMaxPlan:Math.min(LEVEL_CONFIG.mediumMaxPlan,Math.max(4,options.board.length-1))),selectionFraction:easy?LEVEL_CONFIG.easyFraction:LEVEL_CONFIG.mediumFraction});
}
const LETTERS = reference.LETTERS;
export { LETTERS, LEVEL_CONFIG, chooseBotPlacement };
